
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["uploadMultipartFile"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "1533a80f89c6dcce1663.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			